import Vue from 'vue'
import VueRouter from 'vue-router'
//import VueRouter from 'vue-router/dist/vue-router'
//<script src="https://unpkg.com/vue/dist/vue.js"></script>
//<script src="https://unpkg.com/vue-router/dist/vue-router.js"></script>

Vue.use(VueRouter)

const routes = [
  
  /* {
    path: '/',
    name: 'home',
    component: () => import('../views/home/home.vue')
  }, */
  /* {
    path: '/company/what-we-do',
    name: 'what-we-do',
    component: () => import('../views/what-we-do/what-we-do.vue')
  },
  {
    path: '/company/our-story',
    name: 'our-story',
    component: () => import('../views/our-story/our-story.vue')
  },
  {
    path: '/company/executive-management-team',
    name: 'executive-management-team',
    component: () => import('../views/executive-management-team/executive-management-team.vue')
  },
  {
    path: '/company/executive-management-team/jeff-liva',
    name: 'jeff-liva',
    component: () => import('../views/executive-management-team/jeff-liva/jeff-liva.vue')
  },
  {
    path: '/company/executive-management-team/mark-bogan',
    name: 'mark-bogan',
    component: () => import('../views/executive-management-team/mark-bogan/mark-bogan.vue')
  },
  {
    path: '/company/our-team',
    name: 'our-team',
    component: () => import('../views/our-team/our-team.vue')
  },
  {
    path: '/company/mission-statement',
    name: 'mission-statement',
    component: () => import('../views/mission-statement/mission-statement.vue')
  },
  {
    path: '/privacy-policy',
    name: 'privacy-policy',
    component: () => import('../views/privacy-policy/privacy-policy.vue')
  },
  {
    path: '/terms-of-service',
    name: 'terms-of-service',
    component: () => import('../views/terms-of-service/terms-of-service.vue')
  },
  {
    path: '/company/commitment',
    name: 'commitment',
    component: () => import('../views/commitment/commitment.vue')
  },
  {
    path: '/contact',
    name: 'contact',
    component: () => import('../views/contact/contact.vue')
  },
  
  {
    path: '/news',
    name: 'news',
    component: () => import('../views/news/news.vue')
  },
  {
    path: '/careers/:position',
    name: 'careers',
    component: () => import('../views/careers/careers.vue'),
    props: true
  },
  {
    path: '/careers/position/:id',
    name: 'position',
    component: () => import('../views/careers/position.vue'),
    props: true
  },
  {
    path: '/company/solution',
    name: 'solution',
    component: () => import('../views/solution/solution.vue')
  }, 
  {
    path: '/services/covid19-health-management',
    name: 'covid19-health-management',
    component: () => import('../views/service/covid19-health-management.vue')
  },
  {
    path: '/services/covid19-point-of-care',
    name: 'covid19-point-of-care',
    component: () => import('../views/service/covid19-point-of-care.vue')
  },
  {
    path: '/services/department-of-transportation',
    name: 'department-of-transportation',
    component: () => import('../views/service/department-of-transportation.vue')
  },
  {
    path: '/services/health-monitoring',
    name: 'health-monitoring',
    component: () => import('../views/service/fit-for-duty-health-monitoring.vue')
  },
  {
    path: '/services/health-accountability',
    name: 'health-accountability',
    component: () => import('../views/service/health-accountability.vue')
  },*/
 /*
  {
    path: '/services/medical-surveillance-osha',
    name: 'medical-surveillance-osha',
    component: () => import('../views/service/corporate-health-services/medical-surveillance-osha.vue')
  },
  {
    path: '/services/faa-medical-certification',
    name: 'faa-medical-certification',
    component: () => import('../views/service/corporate-health-services/faa-medical-certification.vue')
  },
  {
    path: '/services/uscg-medical-certification',
    name: 'uscg-medical-certification',
    component: () => import('../views/service/corporate-health-services/uscg-medical-certification.vue')
  },
  {
    path: '/services/executive-healthcare',
    name: 'executive-healthcare',
    component: () => import('../views/service/corporate-health-services/executive-healthcare.vue')
  },
  {
    path: '/services/pre-placement-exams',
    name: 'pre-placement-exams',
    component: () => import('../views/service/corporate-health-services/pre-placement-exams.vue')
  },
  {
    path: '/services/fitness-for-duty-exams',
    name: 'fitness-for-duty-exams',
    component: () => import('../views/service/corporate-health-services/fitness-for-duty-exams.vue')
  },
  {
    path: '/services/drug-and-alcohol-testing',
    name: 'drug-and-alcohol-testing',
    component: () => import('../views/service/corporate-health-services/drug-and-alcohol-testing.vue')
  },
  {
    path: '/services/immigration-medical-exams',
    name: 'immigration-medical-exams',
    component: () => import('../views/service/corporate-health-services/immigration-medical-exams.vue')
  },
  {
    path: '/services/independent-medical-exams-ime',
    name: 'independent-medical-exams-ime',
    component: () => import('../views/service/corporate-health-services/independent-medical-exams-ime.vue')
  },
  {
    path: '/services/laboratory-service',
    name: 'laboratory-service',
    component: () => import('../views/service/corporate-health-services/laboratory-service.vue')
  },
  {
    path: '/services/travel-health-services',
    name: 'travel-health-services',
    component: () => import('../views/service/general-health-services/travel-health-services.vue')
  },
  
  {
    path: '/services/substance-abuse-testing',
    name: 'substance-abuse-testing',
    component: () => import('../views/service/general-health-services/substance-abuse-testing.vue')
  },
  {
    path: '/services/workplace-injury-and-illness',
    name: 'workplace-injury-and-illness',
    component: () => import('../views/service/general-health-services/workplace-injury-and-illness.vue')
  },  
  {
    path: '/services/total-absence-management',
    name: 'total-absence-management',
    component: () => import('../views/service/general-health-services/total-absence-management.vue')
  },
  {
    path: '/services/medical-director-service',
    name: 'medical-director-service',
    component: () => import('../views/service/medical-director-service.vue')
  },
  {
    path: '/testimonials/academy',
    name: 'academy',
    component: () => import('../views/service/testimonials/academy.vue')
  },
  {
    path: '/certifications/nys-dept-of-health',
    name: 'academy',
    component: () => import('../views/service/certifications/nys-dept-of-health.vue')
  },
  {
    path: '/information/links',
    name: 'links',
    component: () => import('../views/information/links.vue')
  },
  */

  /* BEGIN MEMBER APP */
  {
    path: '/',
    name: 'signon',
    component: () => import('../views/member-app/authentication/signon.vue')
  },
  {
    path: '/members/invite',
    name: 'member-invites',
    component: () => import('../views/member-app/invite/invite.vue')
  },
  {
    path: '/members/appointments',
    name: 'member-appointments',
    component: () => import('../views/member-app/appointments/appointments.vue')
  },
  {
    path: '/members/my-physicians',
    name: 'physician-search',
    component: () => import('../views/member-app/physician/my-physicians.vue')
  },  
  {
    path: '/members/consent',
    name: 'consent',
    component: () => import('../views/member-app/authentication/consent.vue')
  },
  {
    path: '/members/change-password',
    name: 'change-password',
    component: () => import('../views/member-app/authentication/change-password.vue')
  },
  {
    path: '/members/recover-password',
    name: 'recover-password',
    component: () => import('../views/member-app/authentication/recover-password.vue')
  },
  {
    path: '/consent/optional',
    name: 'optional-consent',
    component: () => import('../views/member-app/consent/optional-consent.vue')
  },
  {
    path: '/members/dashboard',
    name: 'dashboard',
    component: () => import('../views/member-app/dashboard.vue'),
    beforeEnter:(to, from, next) =>
    {
      if (window.sessionKey == '') 
      {
        next('/');
      }
      else
      {
        next();
      } 
    }     
  },
  {
    path: '/members/c19-daily-questionnaire',
    name: 'c19-daily-questionniare',
    component: () => import('../views/member-app/c19/c19-daily-questionnaire.vue'),
    beforeEnter:(to, from, next) =>
    {
      if (window.sessionKey == '') 
      {
        next('/');
      }
      else
      {
        next();
      } 
    } 
  },
  {
    path: '/members/daily-questionnaire',
    name: 'c19-daily-questionniare',
    component: () => import('../views/member-app/c19/daily-questionnaire.vue'),
    beforeEnter:(to, from, next) =>
    {
      if (window.sessionKey == '') 
      {
        next('/');
      }
      else
      {
        next();
      } 
    } 
  },
  {
    path: '/members/my-medical-history',
    name: 'my-medical-history',
    component: () => import('../views/member-app/intake/medical-history.vue'),
    beforeEnter:(to, from, next) =>
    {
      if (window.sessionKey == '') 
      {
        next('/');
      }
      else
      {
        next();
      } 
    } 
  },
  {
    path: '/members/medical-tests',
    name: 'medical-tests',
    component: () => import('../views/member-app/medical-tests/tests.vue'),
    beforeEnter:(to, from, next) =>
    {
      if (window.sessionKey == '') 
      {
        next('/');
      }
      else
      {
        next();
      } 
    } 
  }
  
  /* END MEMBER APP */
  /*{
      path: '*',
      component: () => import('../views/member-app/signon.vue')
  }*/
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
